import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

import { ResultsPresenter } from "../presenters/resultsPresenter";
import Leaderboard from "../views/leaderboardView";
import NavBar from "./NavBar";
import { Home } from "../presenters/homePresenter";
import { observer } from "mobx-react-lite";
import LandingPagePresenter from "../presenters/landingPagePresenter";
import LoginPresenter from "../presenters/loginPresenter";
import SignupPresenter from "../presenters/signupPresenter";
import { AccountPresenter } from "../presenters/accountPresenter";
import { PersonalScoreboardPresenter } from "../presenters/personalScoreboardPresenter";
import { GeneralScoreboardPresenter } from "../presenters/generalScoreboardPresenter";
import { GameplayPresenter } from "../presenters/gameplayPresenter";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebaseModel";
import StaticInfo from "../views/staticInfoView";

const AppRouter = observer(function AppRouter(props) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
    });

    return () => unsubscribe();
  }, []);

  return (
    <Router>
      <div className="flex flex-col h-screen">
        <NavBar model={props.model} />
        <div className="grow overflow-auto">
          <Routes>
            {/* Not signed in accessible */}
            <Route
              path="/"
              element={
                !user ? (
                  <LandingPagePresenter model={props.model} />
                ) : (
                  <Navigate to="/home" replace />
                )
              }
            />
            <Route
              path="/signup"
              element={
                !user ? (
                  <SignupPresenter model={props.model} />
                ) : (
                  <Navigate to="/home" replace />
                )
              }
            />
            <Route
              path="/login"
              element={
                !user ? (
                  <LoginPresenter model={props.model} />
                ) : (
                  <Navigate to="/home" replace />
                )
              }
            />

            {/* Signed in accessible */}
            <Route
              path="/home"
              element={
                user ? (
                  <Home model={props.model} />
                ) : (
                  <Navigate to="/login" replace />
                )
              }
            />
            <Route path="/info" element={<StaticInfo />} />
            <Route
              path="/account"
              element={
                user ? (
                  <AccountPresenter model={props.model} />
                ) : (
                  <Navigate to="/login" replace />
                )
              }
            />
            <Route
              path="/gameplay"
              element={
                user ? (
                  <GameplayPresenter model={props.model} />
                ) : (
                  <Navigate to="/login" replace />
                )
              }
            />
            <Route
              path="/results"
              element={
                user ? (
                  <ResultsPresenter model={props.model} />
                ) : (
                  <Navigate to="/login" replace />
                )
              }
            />
            <Route
              path="/leaderboard"
              element={
                user ? (
                  <Leaderboard model={props.model} />
                ) : (
                  <Navigate to="/login" replace />
                )
              }
            />
            <Route
              path="/personalScoreboard"
              element={
                user ? (
                  <PersonalScoreboardPresenter model={props.model} />
                ) : (
                  <Navigate to="/login" replace />
                )
              }
            />
            <Route
              path="/generalScoreboard"
              element={
                user ? (
                  <GeneralScoreboardPresenter model={props.model} />
                ) : (
                  <Navigate to="/login" replace />
                )
              }
            />
          </Routes>
        </div>
      </div>
    </Router>
  );
});

export default AppRouter;
